/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetAuthClientAudienceRequestBody,
  SetAuthClientAudienceRequestBody$Outbound,
  SetAuthClientAudienceRequestBody$outboundSchema,
} from "../components/setauthclientaudiencerequestbody.js";

export type SetAuthClientAudienceSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type SetAuthClientAudienceRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  setAuthClientAudienceRequestBody: SetAuthClientAudienceRequestBody;
};

/** @internal */
export type SetAuthClientAudienceSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const SetAuthClientAudienceSecurity$outboundSchema: z.ZodMiniType<
  SetAuthClientAudienceSecurity$Outbound,
  SetAuthClientAudienceSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function setAuthClientAudienceSecurityToJSON(
  setAuthClientAudienceSecurity: SetAuthClientAudienceSecurity,
): string {
  return JSON.stringify(
    SetAuthClientAudienceSecurity$outboundSchema.parse(
      setAuthClientAudienceSecurity,
    ),
  );
}

/** @internal */
export type SetAuthClientAudienceRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  SetAuthClientAudienceRequestBody: SetAuthClientAudienceRequestBody$Outbound;
};

/** @internal */
export const SetAuthClientAudienceRequest$outboundSchema: z.ZodMiniType<
  SetAuthClientAudienceRequest$Outbound,
  SetAuthClientAudienceRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    setAuthClientAudienceRequestBody:
      SetAuthClientAudienceRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      setAuthClientAudienceRequestBody: "SetAuthClientAudienceRequestBody",
    });
  }),
);

export function setAuthClientAudienceRequestToJSON(
  setAuthClientAudienceRequest: SetAuthClientAudienceRequest,
): string {
  return JSON.stringify(
    SetAuthClientAudienceRequest$outboundSchema.parse(
      setAuthClientAudienceRequest,
    ),
  );
}
